import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditCertificationsForm } from '../../../components/cv/forms/EditCertificationsForm';
import { useCVData } from '../../../lib/cv-mock-data';
import { useUpsertCertification, useDeleteCertification } from '../../../hooks/useProfileApi';
import { mapCertificationToAPI } from '../../../lib/cv-mapping';
import { assertCvItemBatchSaved } from '../../../lib/cv-write-coordinator';

export default function EditCertificationsWebScreen() {
  const { t } = useTranslation('seeker');
  const { profile, profileRef } = useCVData();
  const upsertCert = useUpsertCertification();
  const deleteCert = useDeleteCertification();
  const initialIdsRef = useRef(new Set(profile.certifications.map((c) => c.id)));

  const handleSave = async () => {
    const items = profileRef.current.certifications;
    const currentIds = new Set(items.map((c) => c.id));
    const removedIds = [...initialIdsRef.current].filter((id) => !currentIds.has(id));
    const results = await Promise.allSettled([
      ...items.map((cert, i) => upsertCert.mutateAsync(mapCertificationToAPI(cert, i))),
      ...removedIds.map((id) => deleteCert.mutateAsync(id)),
    ]);
    // One save, one answer: a CV conflict choice (B02) is reported as such;
    // otherwise only a save where every item failed is a failure.
    assertCvItemBatchSaved(results);
  };

  return (
    <WebEditPageShell title={t('cv.edit.certifications')}>
      <EditCertificationsForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
